export enum AssignmentStatus {
  New = "NEW",
  InProgess = "IN PROGRESS",
  Complete = "COMPLETE"
}

export enum Subjects {
  All = "all",
  Math = "math",
  Reading = "reading",
  Science = "science",
  Purpose = "sel"
}

export enum LessonStatus {
  Completed = "Completed",
  InProgress = "InProgress"
}
